import { useMutation } from '@tanstack/react-query';
import { getSearchVolume } from '../../../services/projects/ProjectService';
import { SearchVolumeResponse } from '../../../models/projects/SearchVolumeResponse';

interface SearchVolumeParams {
  ids: number[];
  questions: string[];
  firmName: string | null;
  projectCountry: string | null;
}

export const useGetSearchVolume = () => {
  const {
    mutateAsync: fetchSearchVolume,
    data: searchVolume,
    isPending: isLoading,
    isError,
    error,
    reset,
  } = useMutation<SearchVolumeResponse[], Error, SearchVolumeParams>({
    mutationFn: ({ ids, questions, firmName, projectCountry }) =>
      getSearchVolume(ids, questions, firmName, projectCountry),
  });

  return {
    fetchSearchVolume,
    searchVolume,
    isLoading,
    isError,
    error,
    reset,
  };
};
